// extracted by mini-css-extract-plugin
export default {"copy":"DnoHz","container":"_WVwk","video":"d_3KL","error":"O7QKi","errorHeading":"zqh2U","refreshButton":"IHSkG","closeButton":"C2Odp"};